(function () {
  angular.module('binky.core.fulfillment-needed', []);
})();
